import { serializable, alias, primitive } from 'serializr';

export class SubFormList {
  @serializable(alias('id', primitive()))
  id?: number;

  @serializable(alias('scenario_name', primitive()))
  scenarioName?: string;
}
